import { render, staticRenderFns } from "./LocationList2.vue?vue&type=template&id=f4ecc448"
import script from "./LocationList2.vue?vue&type=script&lang=js"
export * from "./LocationList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports